var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBrowser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.9987 28H5.9987C4.52536 28 3.33203 26.8067 3.33203 25.3333V6.66667C3.33203 5.19333 4.52536 4 5.9987 4H25.9987C27.472 4 28.6654 5.19333 28.6654 6.66667V25.3333C28.6654 26.8067 27.472 28 25.9987 28Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.33203 10.6667H28.6654",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.33854 7.32016C7.33454 7.32016 7.33188 7.32282 7.33188 7.32682C7.33188 7.33082 7.33454 7.33349 7.33854 7.33349C7.34254 7.33349 7.34521 7.33082 7.34521 7.32682C7.34521 7.32282 7.34254 7.32016 7.33854 7.32016",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7311 7.32016C10.7271 7.32016 10.7245 7.32282 10.7245 7.32682C10.7245 7.33082 10.7271 7.33349 10.7311 7.33349C10.7351 7.33349 10.7378 7.33082 10.7378 7.32682C10.7378 7.32282 10.7351 7.32016 10.7311 7.32016",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1159 7.32016C14.1119 7.32016 14.1092 7.32282 14.1092 7.32682C14.1092 7.33082 14.1119 7.33349 14.1159 7.33349C14.1199 7.33349 14.1226 7.33082 14.1226 7.32682C14.1226 7.32282 14.1186 7.32016 14.1159 7.32016",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBrowser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/browser.f71b398e.svg";
export { ForwardRef as ReactComponent };